import { render } from "./FactorWithSlug.vue?vue&type=template&id=eec4fe0a"
import script from "./FactorWithSlug.vue?vue&type=script&lang=js"
export * from "./FactorWithSlug.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__